module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Maureen turned out to be very thorough in her record keeping, which did not surprise Lily, who said, “She has always been very precise and efficient in everything she does.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her precision, admirable though it was, did nothing to help us learn anything as to her possible whereabouts. Although Maureen was a wealthy woman, she was not careless with money, and she was very meticulous in putting down every dollar she spent, from four-figure designer gowns to eight-dollar lunches, as we found in reviewing her receipts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You look troubled, my dear,” Lily said after I had waded through the last of the folders in the filing cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What I had hoped to find, either in the desk or in the files, was a datebook, or at least a schedule of her activities,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She probably took it with her,” Lily said, but then she snapped her fingers and slapped her forehead lightly. “Of course—I have been a fool, and so have you, although you should be more ashamed than me, having searched through so many homes and offices in the past. It’s back to the bedroom for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I followed Lily, and of course quickly realized what she was talking about. She went straight to the elegant white nightstand with an elegant lamp next to the bed and pulled open the drawer, tossing aside a black sleeping mask and a couple of bottles of pills before holding up a small book, white, of course, and looking at me from over her shoulder with what I would best describe as a triumphant smile.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The shame is on both of us for not thinking about that nightstand right away,” she said as we sat side by side on the bed and began paging through the personal journal, working backward from the last entry, which was more than two weeks ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That last entry, on a Thursday, was "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Katonah weekend")]), _vm._v(", written in her finishing school cursive. “Well, you know that one,” Lily said. “The gathering that Maureen never showed up for.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yeah, and everything covering the last two weeks-plus is blank.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We flipped to the next-to-last notation, on a Wednesday: "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Met Opera, Tannhäuser, L.T.")]), _vm._v(" “Any ideas who this L.T. is?” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily thought for a second, forehead creased, and said, “It must be Lloyd Thorne. I didn’t realize she had been seeing him anymore.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What can you tell me about the man?” I asked, sliding my notebook out of a pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I met him only once, at a single mothers’ benefit at my place, several months ago. You weren’t there that night because you had your weekly poker game at Saul Panzer’s. Thorne seemed like an amiable fellow, a patent attorney at one of the big, prestigious firms in Midtown.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Any idea how Maureen feels about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily shrugged. “Maureen always has been circumspect in discussing her social life. She dates a lot, which should not surprise you, especially given how impressed you seemed to be with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Merely an objective observation,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You did not seem so very objective at that Waldorf cocktail party raising money for women’s shelters. You spent so much time in a corner talking to Maureen that I had to break up your "), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("tête-à-tête and remind you both to circulate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She was just curious about how a private detective works, and to be polite, I was telling her about some of my experiences.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay, that explanation is almost plausible,” she said. “Let’s get back to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We came across a variety of appointments—hairdresser, massage, dress fitting—and meetings, some of which Lily recognized: “"), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("BCR")]), _vm._v(", that’s Breast Cancer Research, "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("WRO")]), _vm._v(", Women’s Rights Organization. I was at that session; I remember it was right here, on Maureen’s terrace.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("More interesting to me were the entries that involved what appeared to be dates, with initials presumably indicating Maureen’s escorts. “Here we have "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Dinner at Sardi’s,")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("J.R.;")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Ballet,")]), _vm._v(" "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("W.T.; Dinner at ‘21,’ E.M.; Gilbert & Sullivan Operetta, C.D.")]), _vm._v(";"), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v(" Knicks game at the Garden")]), _vm._v(", "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("E.M")]), _vm._v(".; "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("BCR Dinner, E.M")]), _vm._v(".,” I told Lily. “Any idea who these guys are—or at least should I assume they’re all guys?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She allowed herself several seconds of looking skyward before her response. “I’m trying to recall which of these men I’ve actually met, and which ones I’ve only heard Maureen mention. Let’s see … J.R., that must be "), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Jason Reed, who is a publisher with Ferris and Reed, which specializes in history and biography, not much fiction. With his company’s tastes, I’m guessing your boss has read some of their titles.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Could be. I can’t keep up with his books, given that he often goes through several in a week, and he keeps Murger’s in business. That’s a—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know, that is a bookstore. And I’ve been in there. Have you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes, but only once to pick up some books Wolfe had ordered, when I just happened to be in that neighborhood,” I said. “Usually, Murger’s makes deliveries to the brownstone, seeing as my boss is a very good customer of theirs. Have you met Jason Reed?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have, once, at an auction benefiting children’s hunger. As you would expect, given Maureen’s obvious desirability, she would attract interesting men, and Jason was both interesting and charming—and not hard on the eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sounds like he may have captivated you,” I remarked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, do you really think that it is only men—including yourself, of course—who are drawn to the opposite sex?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just making an observation, that’s all. Did Maureen have an extended relationship with this dashing and charming publisher?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not that I am aware of,” Lily said. “I did remark to her after meeting Reed that I thought he was quite impressive. I remember she acted rather blasé about the man, as though she didn’t really seem to care one way or the other.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She is hard to please, eh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maybe she sets high standards for herself. Or more likely, she was overly suspicious of all men after her husband’s behavior. I am not sure she saw much of Jason Reed after that night at the auction. I don’t recall her mentioning him again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What do you think of women who in their datebooks use only the initials of the men they’re going out with?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What in the world is wrong with that?” Lily asked. “It’s just a form of shorthand, nothing that’s necessarily secretive.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Does that mean that I am ‘A.G.’ in your calendar on the nights when we go out?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Since you insist on knowing, I always write you down as just plain ‘A.’”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I thought if you used my second initial, it might differentiate me from any Aaron, Anthony, Alan, or Algernon you might be seeing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Believe me, I would never, and I do mean never, date anyone named Algernon. Now, as I said before, let us go back to work before Sofia gets antsy and wonders what’s taking us so long.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thanks for keeping me focused. What can you tell me about W.T., C.D., and E.M.?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That first one would be Will Talmadge, who’s an interesting case,” Lily said. “He inherited millions, or so it’s said, from his father, who made his money in, of all things, electronic cables that run under the streets, if you can believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can believe it. After all, your own late father, who I regret never having met, made his own fortune in the sewer business, so much of his work was also beneath the streets.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“As I’ve said before, you would have liked him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have no doubt whatever of that. Have you met Mr. Talmadge?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have, twice. The best description of him I can come up with is debonair. He is a good deal older than Maureen, dresses exceedingly well, has white hair and a matching mustache, and smokes a pipe. He was divorced years ago and has no offspring I’m aware of. He likes being seen in the company of younger women, and by all accounts, they like being around him, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Does he have a job, or can he just live on the interest from family investments?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Probably the latter. He is a patron of the arts, and he has backed several Broadway plays, and some operas as well. And for the record, he lives in the Dakota.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Which means he brushes shoulders with a lot of other well-known people. Any idea how Maureen feels about him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t. As I have said, she doesn’t talk a lot about the men she sees, and I don’t think she has been out with Talmadge more than a few times.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Moving right along, who, pray tell, is C.D.?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily looked at the ceiling again, as if seeking inspiration. “Mm, that would be … Clay Dalton, whom I know very little about, other than that he comes from a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("family that has made its fortune in the construction business—roads, bridges, tunnels.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I met him just once, when he was with Maureen at a benefit dinner at the Waldorf. He was a little rough around the edges but seemed to be a decent fellow. As I said, his money comes from the construction business. I didn’t get the impression that there was anything serious between them, though.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And what about E.M., the one who seems to pop up most often on our girl’s dance card?” I asked. “Oh, wait. Of course, that’s Eric Mason, the ad guy I met at one of your soirees. The one who was oozing confidence and personality.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He should have a lot of self-confidence,” Lily said. “Eric’s with the agency Gordon and Grove and is among the top creative directors in New York. He’s won both a potful of awards and has earned a big salary in the process.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I see a pattern emerging,” I said. “La Carr appears to enjoy the company of well-heeled gentlemen.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily raised an eyebrow at me. “If you are suggesting that she is a gold digger, I would remind you that Maureen has plenty of money of her own. The fact that she has dated well-off men probably has to do with the social circles she moves in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You make a good point. I do believe we now have plumbed the lady’s diary for all the information that we are likely to get. I’m sure you noticed that the datebook was completely blank after the Katonah weekend. Didn’t that strike you as strange, given how busy our Miss Carr normally is?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It did, and I think I see where you are going with this, Mr. Detective. She has planned to … well, go away.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Certainly possible. What else was missing?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She bit a lip. “I’m not sure what you’re getting at.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We found her diary of activities, all right. But no address book.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah, of course, meaning she has taken it with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Seems likely. Well, we have been in the boudoir long enough. Shall we see if Sofia has learned anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily nodded her agreement and we found the maid in the pantry, where she apparently had been going through the shelves. Before either of us could ask, she replied, “I thought perhaps I might find out if Miss Carr had taken some food, either from here or the refrigerator, but everything seems as I had left it. Except, certain things had to be thrown out of the refrigerator, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Certainly,” Lily said. “What about elsewhere, did everything seem to be in order?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sofia nodded, biting a lip. “I do not like to be a …”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know what you are about to say,” Lily replied, “and I agree that this is very difficult, but we all are worried about Miss Carr. Do you think if we go through her clothes, we will be able to find what she might have taken with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sofia looked more uncomfortable than ever. “But she has so much clothing, Miss Rowan. I would not know what might be missing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I agree, but let us at least take a look. You might have a better idea than I do as to what is in her wardrobe. And among her jewelry, for that matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily gave me a look indicating that I would be of no help whatever in perusing Maureen Carr’s clothes closets and jewel boxes, and I wholeheartedly agreed. The two of them went one way while I headed for the living room, or whatever it was called.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I spent the next forty minutes playing at being a detective, which in this case meant moving through all the other areas in this double-decked palace. I spent the most time in an upstairs room that could pass for a library, with built-in bookshelves along one wall. And before you ask, yes, I opened every book and shook it, and nothing fell out other than one bookmark, from a copy of "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("Arrowsmith")]), _vm._v(" by Sinclair Lewis. The pages where the bookmark had been yielded no clues.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Overall, the rooms I went through gave no indication of a sudden departure by the lady of the house. Other than very light coats of dust on tabletops, everything appeared to be neat and in place, surely a tribute to the conscientiousness of Sofia Jurek and her frequent visits to the apartment. I had just come down from upstairs when Lily and Sofia emerged into the entrance hall from the corridor leading to the bedrooms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, we struck out, to use one of your favorite baseball terms,” Lily told me. “Maureen has so many clothes and so much jewelry that it is almost impossible to tell what she may have gone off with, although for what it’s worth, the string of pearls she loves so much was in place. We also looked in the closet where her suitcases are kept and couldn’t tell if any were missing, because neither Sofia nor I know how many pieces of luggage she had to begin with.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A noble effort, indeed,” I said. “And I regret to tell you I had no success, either. If you two agree with me, we should leave.” I got no argument from either of them, and Sofia’s face registered relief. We said a brief good-bye to the doorman and drove north in silence until I dropped Sofia off in front of her building in Morningside Heights.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am so sorry that I was not of any help,” she said as she stepped out of the convertible. “So very sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We did all that we could,” Lily assured her as I pulled away from the curb. After riding several blocks in silence, Lily said, “But we really haven’t done all that we can.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am open to suggestions.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I really should have said "), _c('span', {
    staticClass: "ORIM-ital"
  }, [_vm._v("I")]), _vm._v(" haven’t done all that I can.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Explain yourself, Miss Rowan.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I plan to talk to each of the men Maureen had been with socially in recent times, starting with the one most recently mentioned in her diary, Lloyd Thorne. From meeting with him, I will work backward.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I would be happy to help,” I said, meaning it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, I know you would, but I have already taken more than enough of your time. This really is my challenge, and what I see as my responsibility. Maureen has been a friend of mine for a long time, probably my closest lady friend, and I would be remiss if I did not try to find out what is going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“May I make a suggestion?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lily smiled. “Well, of course you can; all ideas are welcome.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I assume many of your friends have vacation homes, be they in Florida, or California, the Caribbean, or even Europe. It could be worth checking to see if Maureen might be staying at one of those retreats, since you’ve told me that she doesn’t have a getaway place that she owns.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“An excellent thought,” she said, sighing. “It seems that I have a lot on my plate right now, by choice. I am going to begin my own version of sleuthing tomorrow, and I hope to live up to your high standards, Detective Goodwin.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have no doubt you are ready for the challenge. Just know that I’m available if needed,” I told her as we pulled up in front of her building and embraced.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-304ffc19","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissingHeiress4.vue
// module id = 84
// module chunks = 0